import React__default from 'react';
import cn from 'classnames';

const Spinner = /*#__PURE__*/React__default.forwardRef(function Spinner(props, ref) {
  const {
    delay = 500,
    label,
    ...otherProps
  } = props;
  const [visible, setVisibility] = React__default.useState(!delay);
  React__default.useEffect(() => {
    let timeout;

    if (delay) {
      timeout = window.setTimeout(() => setVisibility(true), delay);
    }

    return () => {
      if (timeout) {
        clearTimeout(timeout);
      }
    };
  }, [delay]);

  if (!visible) {
    return null;
  }

  const className = cn('inline-flex flex-col relative items-center', otherProps.className);
  return React__default.createElement("div", Object.assign({}, otherProps, {
    className: className,
    "data-taco": "spinner",
    ref: ref
  }), React__default.createElement("svg", {
    className: "h-10 w-10 animate-[spinnerRotation_2s_linear_infinite]",
    viewBox: "0 0 100 100",
    xmlns: "http://www.w3.org/2000/svg"
  }, React__default.createElement("circle", {
    cx: "50",
    cy: "50",
    r: "45"
  })), label && React__default.createElement("span", {
    className: "mt-4"
  }, label));
});

export { Spinner };
//# sourceMappingURL=Spinner.js.map
